import { Component, OnInit, Input, Output, EventEmitter, forwardRef, ViewChild, AfterViewInit, ElementRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { MAT_DATE_LOCALE } from '@angular/material';
import * as moment from 'moment';
import { DaterangepickerDirective } from 'ngx-daterangepicker-material';

@Component({
  selector: 'meu-date-range-picker',
  templateUrl: './date-range-picker.component.html',
  styleUrls: ['./date-range-picker.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DateRangePickerComponent),
      multi: true
    }
  ]
})
export class DateRangePickerComponent implements OnInit {
  @Input() placeholderLabel: string;
  @Input() placeholder: string;
  @Input() opens: 'left' | 'center' | 'right' = 'right';
  @Output() result = new EventEmitter();
  selected: any = null;
  @ViewChild(DaterangepickerDirective, { static: false }) pickerDirective: DaterangepickerDirective;
  ranges: any = {
    'Hôm nay': [moment(), moment()],
    'Tuần này': [moment().startOf('isoWeek'), moment().endOf('isoWeek')],
    'Đầu tuần đến hiện tại': [moment().startOf('isoWeek'), moment()],
    'Tháng này': [moment().startOf('month'), moment().endOf('month')],
    '30 ngày gần nhất': [moment().subtract(29, 'days'), moment()],
    'Từ đầu tháng đến hiện tại': [moment().startOf('month'), moment()],
    'Quý này': [moment().startOf('quarter'), moment().endOf('quarter')],
    'Đầu quý đến hiện tại': [moment().startOf('quarter'), moment()],
    'Năm nay': [moment().startOf('year'), moment().endOf('year')],
    'Đầu năm đến hiện tại': [moment().startOf('year'), moment()],
  }
  locate = {
    format: 'DD/MM/YYYY',
    displayFormat: 'DD/MM/YYYY',
    direction: 'ltr',
    weekLabel: 'W',
    'daysOfWeek': [
      'CN',
      'T2',
      'T3',
      'T4',
      'T5',
      'T6',
      'T7'
    ],
    'monthNames': [
      'Th 1',
      'Th 2',
      'Th 3',
      'Th 4',
      'Th 5',
      'Th 6',
      'Th 7',
      'Th 8',
      'Th 9',
      'Th 10',
      'Th 11',
      'Th 12'
    ],
    separator: ' - ',
    cancelLabel: 'Đóng',
    applyLabel: 'Xác nhận',
    customRangeLabel: 'Tùy chọn',
    customRangeDirection: true,
    showRangeLabelOnInput: true,
    firstDay: 1
  }
  constructor() { }
  ngOnInit() {

  }
  ngAfterViewInit(el: ElementRef) {
    /*hide ranges when click custom range*/
    let customRageBtnEl = document.querySelector(".md-drppicker .ranges ul li:last-child button");
    let ranges = document.querySelector(".ranges");
    let inputgroupEl = document.querySelector(".input-group");
    if (customRageBtnEl && ranges) {
      customRageBtnEl.addEventListener('click', function () {
        if (customRageBtnEl.classList.contains("active")) {
          ranges.setAttribute("hidden", "true");
        }
        else {
          ranges.setAttribute("hidden", "false");
        }
      });
    }
    if (inputgroupEl && ranges) {
      inputgroupEl.addEventListener('click', function () {
        ranges.removeAttribute("hidden");
      });
    }
  }

  private _value: any;
  get value() {
    return this._value;
  }
  set value(val) {
    this._value = val;
    this.propagateChange(this._value);
  }
  private propagateChange = (_: any) => { };

  writeValue(value: any): void {
    if (value !== undefined) {
      this.value = value;
    }
  }
  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }
  registerOnTouched(fn: any): void {
    //throw new Error("Method not implemented.");
  }
  setDisabledState?(isDisabled: boolean): void {
    //throw new Error("Method not implemented.");
  }

  rangeClicked(range) {

  }

  datesUpdated(range) {
    // let result = { startDate: null, endDate: null };
    // if (range && range.startDate && range.endDate) {
    //   // result = {
    //   //   'startDate': moment(range.startDate).format('DD/MM/YYYY'),
    //   //   'endDate': moment(range.endDate).add(1, 'days').format('DD/MM/YYYY')
    //   // };
    // }
    this.value = range;
  }
  openDatepicker() {
    if (this.pickerDirective) {
      this.pickerDirective.open();
      if (this.pickerDirective.picker) {
        this.pickerDirective.picker.showCalInRanges = false;
      }
    }
  }
  clearDate() {
    this.selected = null;
    this.value = { startDate: null, endDate: null };
  }

}